const subLedger = {
  path: 'subLedger',
  component: resolve => require(['../../../../../../../pages/admin/merchant/signing/yftAlipay/subLedger'], resolve),
  meta: {isSubLedger: true}
}

export default subLedger
